import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "row mb-2" }
const _hoisted_33 = { class: "col-md-9" }
const _hoisted_34 = { class: "row mb-2" }
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { class: "row mb-2" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "row mb-2" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "row mb-2" }
const _hoisted_44 = { class: "col-md-9" }
const _hoisted_45 = { class: "card-footer" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-2" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_50 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_51 = { class: "col-md-2" }

import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/parceirosService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import UploadFoto from "@/components/UploadFoto/Index.vue";
import DropdownCategoriasParceiros from "@/components/Dropdowns/DropdownCategoriasParceiros.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {


//vue
const route = useRoute();

  var controle = reactive({

    model: {
      parceiroId: 0,
      usuarioId: null,
      nome: "",
      cnpj: null,
      logradouro: null,
      numero: null,
      bairro: null,
      cidadeId: null,
      complemento: null,
      cep: null,
      telefone: null,
      celular: null,
      email: null,
      senha: null,
      observacoes: null,
      ativo: true
    } as unknown as service.Parceiro,
    foto: null as File | null,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: ""
  })

  onMounted(() => {
    
    console.log("buscar")
    
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then((r: any) => {
          controle.model = {
            ...r,
            cidadeId: r.cidadeId === null ? undefined : r.cidadeId
          };
        })
        .catch((error: any) => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setTimeout(() => {
      var el = document.getElementById("inputFocus");
      if (el) {
        el.focus();
      }
    }, 500);

  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)

      // 4. Fazer upload das fotos se existirem
      if (controle.foto != null && controle.foto.size > 0) {

          const arquivo = controle.foto as File
          try {
            controle.status = "Salvando foto...";
            console.log(`Salvando foto...`)
            const urlImagem = await service.uploadFoto(resultado.parceiroId, arquivo)
            console.log(`Salvando foto concluído:`, urlImagem)
            
          } catch (uploadError) {
            controle.erro = `Erro ao salvar foto: ${uploadError}...`;
          }

      }

       controle.status = "Salvo com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
    }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Cadastro de Parceiros",
      items: [ 
      { label: 'Parceiros', to: '/parceiros' }, 
      { label: 'Cadastro', to: '/parceiros/cadastro' } ]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro='')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "empresaId",
                      class: "form-label"
                    }, "ID")
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.parceiroId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.parceiroId) = $event)),
                      id: "parceiroId",
                      formato: 'Numero',
                      readonly: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "nome",
                      class: "form-label obrigatorio"
                    }, "Nome")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.nome,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.nome) = $event)),
                      id: "inputFocus",
                      formato: 'Maiusculo'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "nome",
                      class: "form-label obrigatorio"
                    }, "Categoria")
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(DropdownCategoriasParceiros, {
                      modelValue: _unref(controle).model.categoriaId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.categoriaId) = $event)),
                      id: "categoriaId"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cnpj",
                      class: "form-label"
                    }, "CNPJ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cnpj,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.cnpj) = $event)),
                      id: "cnpj",
                      formato: 'CpfCnpj',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cep",
                      class: "form-label"
                    }, "CEP")
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cep,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.cep) = $event)),
                      id: "cep",
                      formato: 'Cep',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "logradouro",
                      class: "form-label"
                    }, "Logradouro")
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.logradouro,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).model.logradouro) = $event)),
                      id: "logradouro",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "numero",
                      class: "form-label"
                    }, "Número")
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.numero,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).model.numero) = $event)),
                      id: "numero",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "bairro",
                      class: "form-label"
                    }, "Bairro")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.bairro,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.bairro) = $event)),
                      id: "bairro",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cidadeId",
                      class: "form-label"
                    }, "Cidade")
                  ], -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(AutoCompleteCidade, {
                      modelValue: _unref(controle).model.cidadeId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(controle).model.cidadeId) = $event)),
                      id: "cidadeId"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "complemento",
                      class: "form-label"
                    }, "Complemento")
                  ], -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.complemento,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).model.complemento) = $event)),
                      id: "complemento",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "telefone",
                      class: "form-label"
                    }, "Telefone")
                  ], -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.telefone,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(controle).model.telefone) = $event)),
                      id: "telefone",
                      formato: 'Telefone',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "celular",
                      class: "form-label"
                    }, "Celular")
                  ], -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.celular,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(controle).model.celular) = $event)),
                      id: "celular",
                      formato: 'Telefone',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "voucher",
                      class: "form-label"
                    }, "Voucher")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(controle).model.voucher) = $event)),
                      id: "voucher",
                      class: "form-select form-select-sm"
                    }, [...(_cache[34] || (_cache[34] = [
                      _createElementVNode("option", { value: null }, "-- Selecione --", -1),
                      _createElementVNode("option", { value: true }, "Sim", -1),
                      _createElementVNode("option", { value: false }, "Não", -1)
                    ]))], 512), [
                      [_vModelSelect, _unref(controle).model.voucher]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "texto",
                      class: "form-label"
                    }, "Texto")
                  ], -1)),
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).model.texto) = $event)),
                      id: "texto",
                      formato: 'Texto',
                      rows: "3",
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _unref(controle).model.texto]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "responsavel",
                      class: "form-label"
                    }, "Responsável")
                  ], -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.responsavel,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).model.responsavel) = $event)),
                      id: "responsavel",
                      formato: 'Maiusculo',
                      class: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "valorDescontoIni",
                      class: "form-label"
                    }, "Desconto Min R$")
                  ], -1)),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.valorDescontoIni,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(controle).model.valorDescontoIni) = $event)),
                      id: "valorDescontoIni",
                      formato: 'DoisDecimais',
                      class: "end"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "valorDesconto",
                      class: "form-label"
                    }, "Desconto Max R$")
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.valorDesconto,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(controle).model.valorDesconto) = $event)),
                      id: "valorDesconto",
                      formato: 'DoisDecimais',
                      class: "text-end"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "ativo",
                      class: "form-label"
                    }, "Ativo")
                  ], -1)),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(controle).model.ativo) = $event)),
                      id: "ativo",
                      class: "form-select form-select-sm"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: String(tipo.valor),
                          value: tipo.valor
                        }, _toDisplayString(tipo.texto), 9, _hoisted_42))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(controle).model.ativo]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "foto",
                      class: "form-label"
                    }, "Foto")
                  ], -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(UploadFoto, {
                      modelValue: _unref(controle).foto,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(controle).foto) = $event)),
                      id: "foto",
                      accept: 'image/*',
                      alt: 'Foto',
                      imageUrl: _unref(controle).model.arquivo ?? undefined
                    }, null, 8, ["modelValue", "imageUrl"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (salvar()))
                }, "Gravar")
              ]),
              _createElementVNode("div", _hoisted_48, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-md-4" }, null, -1)),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/parceiros'
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})